import { Navigate, Outlet } from 'react-router-dom';

import { useMe } from '@/lib/auth';

import { Header } from './Header';
import { VersionBadge } from './VersionBadge';

export function AppShell() {
  const me = useMe();

  if (me.isPending) {
    return <FullPageMessage>Loading…</FullPageMessage>;
  }

  if (me.isError) {
    return <FullPageMessage tone="error">{(me.error as Error).message}</FullPageMessage>;
  }

  if (!me.data) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex min-h-full flex-col">
      <Header me={me.data} />
      <main className="flex-1">
        <div className="mx-auto max-w-7xl px-4 py-8">
          <Outlet />
        </div>
      </main>
      <footer className="border-t border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900 py-2 dark:border-stone-800 dark:bg-stone-900">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 text-xs text-stone-400 dark:text-stone-500">
          <span>PartForge</span>
          <VersionBadge />
        </div>
      </footer>
    </div>
  );
}

function FullPageMessage({
  children,
  tone,
}: {
  children: React.ReactNode;
  tone?: 'error';
}) {
  return (
    <div className="flex min-h-full items-center justify-center">
      <p className={tone === 'error' ? 'text-red-600' : 'text-stone-500 dark:text-stone-400'}>{children}</p>
    </div>
  );
}
